import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class MonumentMegalithic4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MONUMENT_MEGALITHIC4;
}

export default MonumentMegalithic4PoiTileEntity;
